const baseURL = process.env.REACT_APP_USER_ACCESS_API_URL;

// Helper for auth header
const getAuthHeader = () => {
    const token = localStorage.getItem("token") || "";
    return {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
    };
};

/* ---------------------------
   GET ALL USERS
---------------------------- */
export const getAllUsers = async () => {
    const axios = (await import("axios")).default;

    try {
        const { data } = await axios.get(`${baseURL}users`, {
            headers: getAuthHeader(),
        });
        return data;
    } catch (err) {
        return err;
    }
};

/* ---------------------------
   MY USER DETAILS
---------------------------- */
export const getMyUserDetails = async () => {
    const axios = (await import("axios")).default;

    try {
        const { data } = await axios.get(`${baseURL}users/my-details`, {
            headers: getAuthHeader(),
        });
        return data;
    } catch (err) {
        return err;
    }
};

/* ---------------------------
   GET ALL CLIENTS
---------------------------- */
export const getAllClient = async () => {
    const axios = (await import("axios")).default;

    try {
        const { data } = await axios.get(`${baseURL}clients`, {
            headers: getAuthHeader(),
        });
        return data;
    } catch (err) {
        return err;
    }
};

/* ---------------------------
   USER SIGNUP
---------------------------- */
export const userSignup = async (payload) => {
    const axios = (await import("axios")).default;

    try {
        const { data } = await axios.post(`${baseURL}users/signup`, payload, {
            headers: getAuthHeader(),
        });
        return data;
    } catch (err) {
        return err;
    }
};

/* ---------------------------
   USER ACCESS (Screen Wise)
---------------------------- */
export const getUserAccessScreenWise = async () => {
    const axios = (await import("axios")).default;

    try {
        const { data } = await axios.get(`${baseURL}user-screen-action`, {
            headers: getAuthHeader(),
        });
        return data;
    } catch (err) {
        return err;
    }
};
